module.exports = __webpack_public_path__ + "static/ourMissionFront-b2779e1f7d00a36b224b82679b1e99fd.png";